import styled from 'styled-components';

interface LevelDisplayProps {
  $displayMode: 'compact' | 'full';
}
interface ProgressProps {
  $progress: number;
}

export const Container = styled.div`
  margin-left: 3rem;
  width: 100%;
  display: flex;
  flex-direction: column;

  @media (max-width: 1024px) {
    margin-left: 0;
    margin-top: 2rem;
  }
`;

export const Title = styled.h1`
  display: flex;
  align-items: center;
  font-family: 'RedHatDisplay-Bold';
  line-height: 3rem;
  margin-bottom: 0.5rem;

  > span {
    font-size: 1.56rem;
    color: #1e88e5;
    text-align: center;
    margin-left: 0.6rem;
  }

  @media (max-width: 1024px) {
    justify-content: center;
  }
`;

export const LevelContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const LevelDisplay = styled.div`
  display: flex;
  align-items: flex-start;
  margin-top: 1rem;
  width: 100%;
`;

export const LevelProgressContainer = styled.div<LevelDisplayProps>`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-left: 1.11rem;
`;

export const CurrentLevelIcon = styled.img`
  width: 4.8rem;
`;

export const NextLevelWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  margin-left: 1.11rem;

  @media (max-width: 768px) {
    flex-wrap: wrap;
  }
`;

export const NextLevelIcon = styled.img`
  width: 4.8rem;
  margin-left: 1.11rem;
`;

export const NextLevelRequiriments = styled.div`
  width: 15rem;
  display: flex;
  flex-direction: column;
  margin-left: 0.8rem;

  > h1 {
    font-family: 'RedHatDisplay-Bold';
    color: #323232;
    font-size: 1rem;
  }

  > p {
    font-family: 'RedHatDisplay-Regular';
    color: #666;
    font-size: 0.875rem;
    margin: 0.2rem 0;
  }

  > ul {
    list-style: none;
    padding: 0;
    margin: 0.5rem 0;

    > li {
      display: flex;
      flex-direction: column;
      margin-bottom: 0.5rem;

      > span {
        font-family: 'RedHatDisplay-Bold';
        color: #323232;
        font-size: 0.875rem;
      }

      > p {
        font-family: 'RedHatDisplay-Regular';
        color: #666;
        font-size: 0.75rem;
      }
    }
  }

  @media (max-width: 1024px) {
    margin-left: auto;
  }
`;

export const AccordionLevelsSection = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const LevelCard = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: #f5f5f5;
  border-radius: 0.5rem;
  padding: 1rem;
  margin: 0.5rem;

  > img {
    width: 6.3rem;
  }
`;

export const LevelCardsGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
  width: 100%;
  margin-top: 1rem;

  /* Responsividade para telas menores */
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const DescriptionLevel = styled.div`
  margin-left: 1rem;
  display: flex;
  flex-direction: column;

  > h2 {
    font-family: 'RedHatDisplay-Bold';
    color: #323232;
    font-size: 1.1rem;
    margin: 0 0 0.5rem 0;
    line-height: 1.3;
  }

  > p {
    font-family: 'RedHatDisplay-Regular';
    color: #323232;
    font-size: 0.875rem;
    margin-bottom: 0.5rem;
    line-height: 1.4;
  }

  > span {
    font-family: 'RedHatDisplay-Regular';
    color: #666;
    font-size: 0.75rem;
    margin-bottom: 0.25rem;

    &:last-child {
      margin-bottom: 0;
    }
  }
`;

export const ExtraVerificationWrapper = styled.div`
  display: flex;
  flex-direction: column;

  margin-top: 0.5rem;

  li {
    display: flex;
    align-items: center;
    span {
      font-family: 'RedHatDisplay-Bold';
      color: #323232;
      font-size: 0.875rem;
    }

    p {
      font-family: 'RedHatDisplay-Regular';
      color: #666;
      font-size: 0.75rem;
      margin-bottom: 0.25rem;

      &:last-child {
        margin-bottom: 0;
      }
    }
  }
`;

export const TodoItem = styled.li<{ $isCompleted: boolean }>`
  display: flex;
  align-items: flex-start;
  padding: 0.4rem;
  border-radius: 0.5rem;
  margin-bottom: 0.5rem;
  background-color: ${props =>
    props.$isCompleted ? 'rgba(76, 175, 80, 0.1)' : 'rgba(255, 235, 59, 0.1)'};
  border-left: 3px solid
    ${props => (props.$isCompleted ? '#4CAF50' : '#FFEB3B')};

  .checkmark {
    color: #4caf50;
    margin-right: 0.75rem;
    font-size: 1.2rem;
    flex-shrink: 0;
  }

  .pending {
    color: #ffc107;
    margin-right: 0.75rem;
    font-size: 1.2rem;
    flex-shrink: 0;
  }
`;

export const TodoContent = styled.div`
  display: flex;
  align-items: center;
  gap: 0.89rem;
`;

export const TodoTitle = styled.span<{ $isCompleted: boolean }>`
  font-weight: bold;
  display: block;
  margin-bottom: 0.25rem;
  color: ${props => (props.$isCompleted ? '#4CAF50' : 'inherit')};
  text-decoration: ${props => (props.$isCompleted ? 'line-through' : 'none')};
`;

export const TodoDescription = styled.p`
  font-size: 0.9rem;
  margin-bottom: 0.25rem;
  color: #666;
`;

export const TodoProgress = styled.span`
  background: #f1f1f1;
  border-radius: 10px;
  padding: 0.2rem 0.5rem;
  font-size: 0.8rem;
  display: inline-block;
`;

export const TodoList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0.5rem 0;
`;

export const LevelTitle = styled.h2`
  font-family: 'RedHatDisplay-Bold';
  color; #323232;
  font-size: 1rem;
  margin: 0;
`;

export const LevelProgressBar = styled.div`
  margin: 0.3rem 0;
  height: 1rem;
  width: 100%;
  background-color: #e2e2e2;
  border-radius: 5.56rem;
`;

export const Fill = styled.div<ProgressProps>`
  width: ${props => props.$progress}%;
  height: 100%;
  background: linear-gradient(90deg, #ff9800, #ff6d00);
  border-radius: inherit;
  text-align: right;
`;

export const PointsLabel = styled.span`
  font-size: 1rem;
  color: #666;
`;

export const BadgesContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 2rem;
`;

export const BadgesGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  gap: 1rem;
  width: 100%;
  margin-top: 1rem;

  @media (max-width: 1024px) {
    grid-template-columns: 1fr 1fr 1fr;
  }

  /* Responsividade para telas menores */
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const BadgeEarned = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 7.78rem;
  background-color: rgba(76, 175, 80, 0.1);
  border-radius: 0.75rem;
  border: 1px solid #4caf50;
  padding: 1.5rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition:
    transform 0.2s ease,
    box-shadow 0.2s ease;
  text-align: center;

  > img {
    width: 4.78rem;
    height: 4.78rem;
    object-fit: contain;
    margin-bottom: 0.75rem;
  }

  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }

  > p {
    font-family: 'RedHatDisplay-Regular';
    color: #323232;
    font-size: 0.875rem;
    margin: 0.5rem 0;
    line-height: 1.4;
    flex: 1;
  }

  > span {
    font-family: 'RedHatDisplay-Regular';
    color: #323232;
    font-size: 0.75rem;
    margin-top: auto;
    padding-top: 0.5rem;
    text-align: center;
  }

  @media (max-width: 1024px) {
    padding: 1rem;
  }
`;

export const BadgeCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #f8f9fa;
  border-radius: 0.75rem;
  border: 1px solid #e0e0e0;
  padding: 1.5rem;
  min-height: 7.78rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition:
    transform 0.2s ease,
    box-shadow 0.2s ease;

  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }

  > img {
    width: 2.78rem;
    height: 2.78rem;
    object-fit: contain;
    margin-bottom: 0.75rem;
  }

  > h2 {
    font-family: 'RedHatDisplay-Bold';
    color: #323232;
    font-size: 1rem;
    margin: 0;
    text-align: center;
    line-height: 1.3;
  }
`;

export const DescriptionBadge = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;

  > p {
    font-family: 'RedHatDisplay-Regular';
    color: #666;
    font-size: 0.875rem;
    margin: 0.5rem 0;
    line-height: 1.4;
  }

  > span {
    font-family: 'RedHatDisplay-Regular';
    color: #999;
    font-size: 0.75rem;
    margin-top: 0.25rem;
  }
`;
